import { ChangeDetectionStrategy, Component, Inject, TemplateRef } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface MessageDialogModel {
  textMessage?: string;
  templateMessage?: TemplateRef<any>;
}

@Component({
    selector: 'app-message-dialog',
    templateUrl: './message-dialog.component.html',
    styleUrls: ['./message-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MessageDialogComponent  {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: MessageDialogModel
  ) { }


}
